import {AuthenticationContext} from 'react-adal';

export const adalConfig = {
  tenant: '462ad9ae-d7d9-4206-b874-71b1e079776f',
  clientId: 'e784ad50-b9b8-4db2-a171-ddfc7cd637ac',
  endpoints: {
    api: 'e784ad50-b9b8-4db2-a171-ddfc7cd637ac',
  },
  cacheLocation: 'localStorage',
  redirectUri: window.location.href.replace(window.location.pathname, '/'),
  postLogoutRedirectUri: window.location.origin,
};

export const authContext = new AuthenticationContext(adalConfig);
